document.addEventListener("DOMContentLoaded", function() {
    function initOpenPopupMore(){
        const upsellButtons = document.querySelectorAll(".product-single__upsell-text .text-link, .cart-bottom__upsell .text-link");
        if (upsellButtons) {
            upsellButtons.forEach(button => {
                button.addEventListener("click", function(event) {
                    event.preventDefault();
                    let popupId = this.getAttribute("href");
                    console.log('open popup');
                    if(document.querySelector(`${popupId}`).closest('.product__info-container--sticky') != null){
                        document.querySelector(`${popupId}`).closest('.product__info-container--sticky').style.zIndex = "5";
                    }
                    document.body.style.overflow = "hidden";
                    document.querySelector(`${popupId}`).classList.remove("hidden");
                });
            });
        }
    }

    function initOpenPopupBackpack() {
        const popupUpsellBackpack = document.querySelector('#popup_upsell_backpack');

        if (!popupUpsellBackpack) {
            const mainAddButton = document.querySelector('input[data-variant-id]:checked');

            if (!mainAddButton) {
                console.error('Not found variant id for main product');
                return;
            }

            const mainVariantId = mainAddButton.dataset.variantId;

            if (!mainVariantId) {
                console.error('Not found variant id of main product');
                return;
            }
            console.log('mainVariantId', mainVariantId);
            const items = [
                { id: mainVariantId, quantity: 1 }
            ];

            addItemsToCart(items);
            return;
        }else{
            console.log('not found popupUpsellBackpack');
        }

        document.body.style.overflow = "hidden";
        popupUpsellBackpack.classList.remove("hidden");

        console.log('open popup');
        if(popupUpsellBackpack.closest('.product__info-container--sticky') != null){
            popupUpsellBackpack.closest('.product__info-container--sticky').style.zIndex = "5";
        }

        const buttons = document.querySelectorAll(".product-single__upsell-popup__buttons button");

        buttons.forEach(button => {
            button.addEventListener("click", async function (event) {
                event.preventDefault();

                const clickedVariantId = this.dataset.variantId;
                if (!clickedVariantId) {
                    console.error('Не знайдено variant id у кнопці');
                    return;
                }

                if (this.classList.contains("button--primary")) {
                    const mainVariantButton = this.closest('.product-single__upsell-popup__buttons').querySelector('.button--secondary');
                    const mainVariantId = mainVariantButton.dataset.variantId;

                    if (!mainVariantId) {
                        console.error('Основний variant id не знайдено');
                        return;
                    }

                    const items = [
                        { id: mainVariantId, quantity: 1 },
                        { id: clickedVariantId, quantity: 1 }
                    ];

                    await addItemsToCart(items);
                }
                else {
                    const items = [
                        { id: clickedVariantId, quantity: 1 }
                    ];

                    await addItemsToCart(items);
                }
            });
        });

        async function addItemsToCart(items) {
            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });

                if (response.ok) {
                    const data = await response.json();
                    console.log("Товари додано:", data);
                    window.location.href = window.routes.cart_url;
                } else {
                    console.error('Error added to cart', await response.text());
                }
            } catch (error) {
                console.error('Error request:', error);
            }
        }
    }

    function initUpsellButtonHandler() {
        const upsellBtn = document.querySelector('.product-single__upsell-btn');

        if (!upsellBtn) return;

        upsellBtn.addEventListener('click', async function (event) {
            event.preventDefault();

            const rawIds = this.dataset.productsId;
            const successText = this.dataset.addedText;

            if (!rawIds) {
                console.error('Missing data-products-id attribute');
                return;
            }

            const ids = rawIds
                .split(',')
                .map(id => id.trim())
                .filter(id => id !== '');

            if (ids.length === 0) {
                console.error('No valid variant IDs found');
                return;
            }

            const items = ids.map(id => ({
                id,
                quantity: 1
            }));

            try {
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items })
                });

                if (response.ok) {
                    // Update button UI
                    const span = this.querySelector('span');
                    if (span && successText) {
                        span.textContent = successText;
                    }
                    this.classList.add('active');

                    // Redirect to cart after 500ms
                    setTimeout(() => {
                        window.location.href = window.routes?.cart_url || '/cart';
                    }, 500);
                } else {
                    console.error('Failed to add items to cart:', await response.text());
                }
            } catch (error) {
                console.error('Request error:', error);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', initUpsellButtonHandler);


    function initializeSliders() {
        let slidersPopup = document.querySelectorAll(".product-single__upsell-popup__images.owl-carousel");
        console.log('slidersPopupLearnMore', slidersPopup)
        if (slidersPopup.length > 0) {
            slidersPopup.forEach((element) => {
                console.log('element', element);
                $(element).owlCarousel({
                    loop: true,
                    dots: false,
                    nav: true,
                    responsiveClass: true,
                    lazyLoad: true,
                    startPosition: 0,
                    responsive: {
                        0: {
                            margin: 5,
                            items: 1
                        },
                        768: {
                            margin: 5,
                            items: 3
                        }
                    }
                });
            });
        }
    }
    function initPopups() {
        let upsellPopup = document.querySelectorAll('.upsell-popup');
        if (upsellPopup.length > 0) {
            upsellPopup.forEach((popup) => {
                let closePopup = popup.querySelector(".page-popup__close");
                if(closePopup != null){
                    closePopup.addEventListener("click", function(event) {
                        event.preventDefault();
                        document.body.style.overflow = "";
                        this.closest(".upsell-popup").classList.add("hidden");

                        if(this.closest('.product__info-container--sticky') != null){
                            this.closest('.product__info-container--sticky').style.zIndex = "2";
                        }
                    });
                }
            });
        }
    }
    function initUpsellBuy() {
        const productFormEl  = document.querySelector("product-form");
        const formBuy = productFormEl?.querySelector("form");
        console.log('formBuy', formBuy);

        if(formBuy != null){
            formBuy.addEventListener("submit", function(event) {
                event.stopImmediatePropagation();
                event.preventDefault();
                initOpenPopupBackpack();
            }, true);
        }
    }
    function initChangeVariant() {
        const inputsVariant = document.querySelectorAll(".product-form__input input[type='radio']");

        if (inputsVariant.length > 0) {
            inputsVariant.forEach((input) => {
                input.addEventListener("change", async function (event) {
                    let _this = this;
                    const variantId = this.dataset.variantId;
                    const productUrl = window.location.pathname + `?variant=${variantId}`;
                    try {
                        const response = await fetch(productUrl);
                        if (!response.ok) {
                            throw new Error(`Failed to fetch product page: ${response.status}`);
                        }

                        console.log('chenge variant', variantId, productUrl);

                        const htmlText = await response.text();
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(htmlText, 'text/html');

                        const newUpsellsContainer = doc.querySelector('.product-single__upsells-wrapper');
                        const newUpsellPopups = doc.querySelector('.upsell-popups');

                        const currentUpsellsContainer = document.querySelector('.product-single__upsells-wrapper');
                        const currentUpsellPopups = document.querySelector('.upsell-popups');

                        const currentBuyButtonPrice = document.querySelector('#AddToCartPrice');
                        const currentBuyButtonPriceNew = doc.querySelector('#AddToCartPrice');

                        const currentSoldOutNotification = document.querySelector('.product-single__outofstock-message');
                        const currentSoldOutNotificationNew = doc.querySelector('.product-single__outofstock-message');

                        if(currentSoldOutNotification && currentSoldOutNotificationNew) {
                            currentSoldOutNotification.innerHTML = currentSoldOutNotificationNew.innerHTML;
                            if (currentSoldOutNotificationNew.classList.contains('hide')) {
                                currentSoldOutNotification.classList.add('hide');
                            } else {
                                currentSoldOutNotification.classList.remove('hide');
                            }
                        }

                        if (newUpsellsContainer && currentUpsellsContainer) {
                            currentUpsellsContainer.innerHTML = newUpsellsContainer.innerHTML;
                        }else if( currentUpsellsContainer !== null){
                            currentUpsellsContainer.innerHTML = '';
                        }

                        if (newUpsellPopups && currentUpsellPopups) {
                            currentUpsellPopups.innerHTML = newUpsellPopups.innerHTML;
                        }

                        if( currentBuyButtonPrice && currentBuyButtonPriceNew) {
                            currentBuyButtonPrice.innerHTML = currentBuyButtonPriceNew.innerHTML;
                        }

                        // if( soldOutMassage && soldOutMassageNew) {
                        //     soldOutMassage.innerHTML = soldOutMassageNew.innerHTML;
                        //     if(soldOutMassageNew.classList.contains('hide')) {
                        //         soldOutMassage.classList.add('hide');
                        //     }else{
                        //         soldOutMassage.classList.remove('hide');
                        //     }
                        // }

                        initOpenPopupMore();
                        initializeSliders();
                        initPopups();
                        initUpsellBuy();
                        initChangeVariantImages(_this);

                        if (typeof initUpsellButtonHandler === 'function') {
                            initUpsellButtonHandler();
                        }

                    } catch (error) {
                        console.error('Error updating upsell sections:', error);
                    }
                });
            });
        }
    }
    function initUpsellBuyCart(){
        const upsellButtons = document.querySelectorAll('.cart-bottom__upsell-btn');

        upsellButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                const variantId = button.getAttribute('data-variant-id');

                if (!variantId) {
                    console.error('Not found variant ID');
                    return;
                }

                button.disabled = true;
                button.textContent = window.transations.adding;

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: 1
                    })
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error('Error adding item to cart: ' + response.statusText);
                        }
                        return response.json();
                    })
                    .then(data => {
                        location.reload();
                    })
                    .catch(error => {
                        console.error('Error:', error);
                        button.disabled = false;
                        button.textContent = 'Error, try again';
                    });
            });
        });
    }
    function initChangeVariantImages(_this){
        let productList = document.querySelectorAll('.product__media-item');
        if(productList.length > 0){
            productList.forEach((element) => {
                if(!element.classList.contains('hidden')){
                    element.classList.add('hidden');
                }
                console.log('values - ', element.getAttribute('data-variant-name'), _this.getAttribute('value'));
                if(element.getAttribute('data-variant-name') == _this.getAttribute('value')) {
                    element.classList.remove('hidden');
                }
            })
        }
    }



    initOpenPopupMore();
    initUpsellButtonHandler();
    initializeSliders();
    initPopups();
    initUpsellBuy();
    initChangeVariant();
    initUpsellBuyCart();
})